import state from './kioskKpiState';
import mutations from './kioskKpiMutations';
import actions from './kioskKpiActions';
import getters from './kioskKpiGetters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
